import React from 'react'
import styles from './commission-modal.scss'
import Modal from 'jd-library/Modal';
import Button from 'jd-library/Button';

const CommissionModal = (props) => {
    let rate = '';
    if(props.commissionRate){
        rate = Number(props.commissionRate)
    }
    return (
        <Modal
            settings= {{
                modalId: 'commissionModal',
                variant: 'action',
                class: props.webStyle ? styles['commission-modal-web'] : styles['commission-modal-mob'],
                modalInsideSlider: true
            }}
            onHidden={()=>{props.onHidden()}} 
        >
            <Modal.CloseIcon />
            {props.fromListing && <Modal.Header>Commission Rate Present</Modal.Header>}
            <Modal.Body className={styles['commission-modal']}>
                <div className={styles['info-text']}>
                    {
                        props.fromListing ? 
                            props.commissionRate ? 
                            <>You have entered <span>{rate}% commission rate</span> for this product. Please click the button below to confirm and continue approving this product</>:
                            <>The selected products have a commission rate entered in them. Please click on the button below to confirm and continue approving these products</>
                        :
                            <>You have entered <span>{rate}% commission rate</span> for this product. Please click the button below to confirm and continue saving this product</>
                    }
                    
                </div>
                <Button
                    size='lg'
                    block
                    onClick={(e) => {props.onSave(e)}}
                >
                    Confirm and {props.fromListing ? 'Approve' : 'Save'}
                </Button>
            </Modal.Body>
        </Modal>
    )
}

export default CommissionModal